import { useLocaleRestriction } from "./useLocaleRestriction";

const CASE_STUDY_ALLOWED_LOCALES = ["en-US"] as const;

export const useCaseStudyLocaleRestriction = () => {
  const { locale, isAllowed } = useLocaleRestriction();

  return {
    locale,
    isAllowed: isAllowed(CASE_STUDY_ALLOWED_LOCALES),
  };
};
